// App imports
import { BaseService } from '@zaoblako/web/core/services/base.service';

// Shared imports
import { NumberPrefixEnum } from '@zaoblako/shared/common/enums/number-prefix.enum';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PassageTaskLkFindManyQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task-lk/passage-task-lk-find-many-query.dto';
import type { PassageTaskLkPageInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task-lk/passage-task-lk-page.dto';
import type { PassageTaskLkFindInterface } from '@zaoblako/shared/modules/pacs/dtos/passage-task-lk/passage-task-lk-find.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';

// External libs imports
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountPassageTaskService extends BaseService {
  protected baseUrl = '/personal-account/pacs/passage-task';

  protected numberPrefix = NumberPrefixEnum.PASSAGE_TASK_PREFIX;

  public getCardDescriptor(taskId?: number): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`, {
      params: taskId ? { taskId } : {}
    });
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findMany(query?: PassageTaskLkFindManyQueryInterface): Observable<PassageTaskLkPageInterface> {
    return this.http.get<PassageTaskLkPageInterface>(`${this.baseUrl}/items`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }

  public restoreOneById(id: number): Observable<PassageTaskLkFindInterface> {
    return this.http.post<PassageTaskLkFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public restoreOneByNumber(number: number): Observable<PassageTaskLkFindInterface> {
    return this.http.post<PassageTaskLkFindInterface>(`${this.baseUrl}/${this.numberPrefix}-${number}/restore`, {});
  }

  public getHistoryForOneById(id: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }

  public getHistoryForOneByNumber(number: number, query?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${this.numberPrefix}-${number}/history`, {
      params: query
        ? this.objectToHttpParams(query)
        : {}
    });
  }
}
